import React, { useCallback, useEffect, useState } from "react";
import { professionalExperienceTranslate, wheelCollaboratorTranslate } from "../../i18n/translatedMessages";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { useIntl } from "react-intl";
import Swal from "sweetalert2";
import { getCandidateProfesionalExperiences, postCandidateExperience } from "../../API/Candidates/Experience";
import { getIndustryTypeList } from "../../API/Lists/industryType";
import { getAreaList } from "../../API/Lists/area";
import { getHierarchicalLevelList } from "../../API/Lists/hierarchicalLevel";
import { FormacionIcon } from "../../Icons/CollaboratorsIcons";
import ProfessionalExperienceAccordion from "./Components/ProfesionalExperieneComponent/ProfessionalExperienceAccordion";
import Loading from "../../Components/Loading/Loading";

const ProfessionalExperience = () => {
	const language = useIntl();
	const objEmpty = {
		company: "",
		jobname: "",
		entry_date: "2000-01-01",
		description: "",
		industry_id: 0,
		hierarchical_level_id: 0,
		area_id: 0,
		achievements: "",
		departure_date: "Actual",
	};

	const [dataExperiences, setDataExperience] = useState([objEmpty]);
	const [activeItem, setActiveItem] = useState(null);
	const [updateActiveItem, setUpdateActiveItem] = useState(false);
	const [isLoading, setIsLoading] = useState(true);
	const [industryList, setIndustryList] = useState([]);
	const [areaList, setAreaList] = useState([]);
	const [hierarchicalLevelList, setHierarchicalLevelList] = useState([]);

	const [isChecked, setIsChecked] = useState([]);

	const handleCheckboxChange = (index) => {
		const updatedCheckboxValues = [...isChecked];
		updatedCheckboxValues[index] = !updatedCheckboxValues[index];
		setIsChecked(updatedCheckboxValues);
	};

	const fetchData = useCallback(async () => {
		const industryTypeList = await getIndustryTypeList()
			.then((response) => response)
			.catch(() =>
				Swal.fire({
					text:
						language.locale === "PT-BR"
							? "Erro ao solicitar dados do servidor, aguarde alguns instantes e atualize a página!"
							: "Error al solicitar datos del servidor, espera unos momentos y actualiza la página!",
					icon: "warning",
				})
			);

		console.log(industryList);
		setIndustryList(industryTypeList || []);
		setAreaList(await getAreaList());
		setHierarchicalLevelList(await getHierarchicalLevelList());
	}, []);

	useEffect(() => {
		fetchData();
		return () => {
			setIndustryList([]);
			setAreaList([]);
			setHierarchicalLevelList([]);
		};
	}, []);

	useEffect(() => {
		async function getExperienceCandidate() {
			const data = await getCandidateProfesionalExperiences(localStorage.getItem("candidateId"));

			if (data.message && Object.keys(data.message).length === 0) {
				// No hay registros en tabla candidato
				setDataExperience([objEmpty]);
				setIsLoading(false);
			} else {
				const aux = data.items.professional_experiences.map((item) => ({
					...item,
					industry_id: item.industry,
				}));
				const sortedExperiences = aux.sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
				setDataExperience(sortedExperiences);
				setActiveItem((parseInt(sortedExperiences.length) - 1).toString());
				setIsLoading(false);
			}
		}
		getExperienceCandidate();
	}, []);

	const handleChange = (event) => {
		setUpdateActiveItem(true);
		const { name, value } = event.target;
		const index = event.target.getAttribute("data-index");

		const aux = [...dataExperiences];
		aux[index][name] = name === "industry_id" ? Number(value) : value;
		setActiveItem(index);
		setDataExperience(aux);
	};

	const handleAdd = () => {
		setDataExperience((prevData) => [...prevData, objEmpty]);
		setActiveItem(parseInt(dataExperiences.length).toString());
	};

	useEffect(() => {
		if (!updateActiveItem) {
			// Actualiza el valor de activeItem con el tamaño actualizado de dataExperiences
			setActiveItem((parseInt(dataExperiences.length) - 1).toString());
		}
	}, [dataExperiences]);

	const handleSend = async (i) => {
		const body = dataExperiences.map((item) => ({
			company: item.company,
			jobname: item.jobname,
			entry_date: item.entry_date,
			description: item.description,
			industry_id: item.industry_id,
			area_id: item.area_id,
			hierarchical_level_id: item.hierarchical_level_id,
			achievements: item.achievements,
			departure_date: item.departure_date,
		}));

		body[i].departure_date = isChecked[i] ? "Actual" : body[i].departure_date;

		if (
			dataExperiences[i].company === "" ||
			dataExperiences[i].jobname === "" ||
			dataExperiences[i].industry_id === 0 ||
			dataExperiences[i].area_id === 0 ||
			dataExperiences[i].hierarchical_level_id === 0
		) {
			Swal.fire({
				icon: "error",
				title: "Oops...",
				text: "Hay campos obligatorios que no han sido cumplimentados!",
			});
			return;
		}

		const dateStart = new Date(`${dataExperiences[i].entry_date}T23:59:59`);
		const dateEnd = new Date(`${dataExperiences[i].departure_date}T00:00:00`);
		const today = new Date();

		if (isNaN(dateStart) || (!isChecked[i] && isNaN(dateEnd)) || dateStart >= today || (!isChecked[i] && dateEnd > today) || (!isChecked[i] && dateStart > dateEnd)) {
			Swal.fire({
				icon: "error",
				title: "Oops...",
				text: "Los valores de fecha no son válidos!",
			});
			return;
		}

		setIsLoading(true);

		if (dataExperiences[i].industry_id && dataExperiences[i].industry_id !== 0) {
			await postCandidateExperience(localStorage.getItem("candidateId"), body)
				.then(
					Swal.fire({
						text: language.locale === "PT-BR" ? "O envio foi feito com êxito!" : "El envío se ha efectuado con exito!.",
						icon: "success",
					}).then(() => {
						setIsLoading(false);
						window.location.reload();
					})
				)
				.catch((error) => {
					Swal.fire({
						text: error || language.locale === "PT-BR" ? "Selecione uma industria!" : "Seleccione una industria!",
						icon: "warning",
					}).then(() => {
						setIsLoading(false);
					});
				});
		}
	};

	return (
		<>
			<div className="row mb-4 align-items-center sideMenuSeparator">
				<div className="col-2">
					<span className="title-icon p-2 m-auto">
						<FormacionIcon size={20} />
					</span>
				</div>
				<div className="col-10">
					<h1>{wheelCollaboratorTranslate.professionalHistoric}</h1>
					<p className="description-section">{professionalExperienceTranslate.professionalExperienceDesc}</p>
				</div>
			</div>
			<>
				{isLoading ? (
					<>
						<Loading />
					</>
				) : (
					<>
						<div className="row mb-2 d-flex justify-content-end">
							<div style={{ maxWidth: "150px" }}>
								<button className="btn rounded-pill addEmployeeInfo-btn" onClick={handleAdd}>
									Add <AiOutlinePlusCircle size={25} />
								</button>
							</div>
						</div>
						<div className="row sideMenuSeparator px-2">
							{activeItem !== null && (
								<ProfessionalExperienceAccordion
									itemActive={activeItem}
									experiences={dataExperiences}
									industryList={industryList}
									areaList={areaList}
									hierarchicalLevelList={hierarchicalLevelList}
									handleChange={(e) => handleChange(e, activeItem)}
									handleSend={() => handleSend(activeItem)}
									isChecked={isChecked}
									setIsChecked={setIsChecked}
									handleCheckboxChange={handleCheckboxChange}
								/>
							)}
						</div>
					</>
				)}
			</>
		</>
	);
};

export default ProfessionalExperience;
